import firebase from 'firebase';

export default  {
  name: "MaintenanceChecklistDlg",
  data() {
    return {
      dialog: false,
      requestId: null,
      checklist: null,
      loading: false,
    }
  },
  methods: {
    open(request: any) {
      this.dialog = true;
      this.requestId = request.id;
      this.checklist = request.checklist;
    },
    close() {
      this.dialog = false;
    },
    async saveChecklist() {
      this.loading = true;

      await firebase.firestore()
        .collection("maintenanceRequests")
        .doc(this.requestId)
        .update({
          checklist: this.checklist
        }).then(async () => {
          await this.$store.dispatch('getMaintenanceRequest', this.$route.params.id);

          this.$toast.open({
            type: "success",
            message: this.$t("MaintenanceView.ChecklistSuccessfullySaved")
          })
          this.close();
        }).catch(err => {
          console.error("Error: ", err.message);
        }).finally(() => {
          this.loading = false;
        })
    }
  }
}